import SidebarMenu from '@/components/SidebarMenu/SidebarMenu.vue'

export default {
  install (Vue) {
    Vue.component('sidebar-menu', SidebarMenu)
  }
}

export { SidebarMenu }
